/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { useAppConfig } from '../hooks/useAppConfig';
import { get } from 'lodash';
import { AIcon as Icon } from '../icon';
import colors from '../colors';

export interface IProps extends ButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  title?: string;
  disabled?: boolean;
  outline?: boolean;
  dark?: boolean;
  css?: any;
}

let defaults = ``;

export const _Button = (props: IProps) => {
  const app = useAppConfig();
  const { title, children, dark } = props;

  // tslint:disable-next-line:no-any
  const fs = { ...props } as any;
  fs.outline = !!props.outline ? 'true' : 'false';
  fs.type = fs.type || 'primary';
  delete fs.dark;

  let style = defaults;

  if (fs.type === 'link') {
    style += `
      color: ${get(app, 'style.colors.primary')};
      &:hover {
        color: ${get(app, 'style.colors.primary')} !important;
      }
    `;
  }

  if (dark && !props.outline && !props.disabled) {
    style += `
      background-color: ${colors.buttonDark};
      border-color: ${colors.buttonDark};
      color: ${colors.white};
      &:hover, &:focus {
        background-color: ${colors.buttonDark} !important;
        border-color: ${colors.buttonDark} !important;
        color: ${colors.white} !important;
        opacity: 0.85;
      }
    `;
  }

  if (props.icon && typeof props.icon == 'string') {
    fs.icon = <Icon type={props.icon} />;
  }

  return (
    <Button {...fs} ghost={!!props.outline} css={css(style, props.css)}>
      {title || children}
    </Button>
  );
};
